import * as React from "react";
import { RESTContext } from "../../core/rest.context"
import {
    BACK_IN_STOCK_LISTING_ENABLED, BRX_ASSETS_URL, BRX_BASE_URL,
    calls,
    PRODUCT_WITH_LIMITED_QTA_ENABLED, PROJECT_COUNTRY,
    PROJECT_LANGUAGE,
    PROJECT_SETTINGS, SHOW_ENERGY_LABEL
} from "../../core/APIUtils"
import ReactDOM from "react-dom";
import {LabelContext} from "../../core/label.context";
import {SymbolContext} from "../../core/symbol.context";
import {CartContext} from "../../core/cart.context";
import {GeneralContext} from "../../core/general.context";
import {getContentVisibility, getCurrentPrice, getEnergyClassLabel} from "./utils";
import {openCartLayer, parsePrice} from "../../common/constants";



export const SparepartsListComponent = (props: any) => {
    const { ajax$ } = React.useContext(RESTContext);
    const [products, setProducts] = React.useState<any>([]);
    const container = document.querySelector(".reactPlaceholder_spareParts")


    React.useEffect(() => {
        ajax$(calls.Project.getProductProjection('productType.id:"' + PROJECT_SETTINGS['sparePartsId'] + '"&expand=masterVariant.attributes[*].value[*]'))
            .subscribe(
                res => {
                    setProducts(res.results)
                })
    }, []);

    if (products.length <= 0 || !container)
        return null;
    else {
        return ReactDOM.createPortal(
            <div className="row listItem row products-list">
                {products.map((item: any, i: any) => (
                    <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4 product-preview" key={i}>
                        <SparePartItem item={item}/>
                    </div>
                ))}
            </div>
        ,container)
    }
}

export const SparePartItem = (props: any) => {
    const {item} = props;
    const {t} = React.useContext(LabelContext);
    const {getSymbolBySku} = React.useContext(SymbolContext);
    const {addLineItem, addRemoveWishlistLineItem} = React.useContext(CartContext);
    const {wishlist, setOpenBackInStock, openBackInStock, userData} = React.useContext(GeneralContext);
    const [isAvailable, setIsAvailable] = React.useState(false)
    const [itemWillArriveLater, setItemWillArriveLater] = React.useState(false)
    const [showLabelItemInStockWithLimitedQta, setShowLabelItemInStockWithLimitedQta] = React.useState(false)
    const [showLabelItemInStock, setShowLabelItemInStock] = React.useState(false)
    const [availableQta, setAvailableQta] = React.useState(0)
    const [showBackInStock, setShowBackInStock] = React.useState(false)
    const [isSellable, setIsSellable] = React.useState(false)

    let currentItem: any;
    let name: string;
    let backInStockActive = Boolean(BACK_IN_STOCK_LISTING_ENABLED === 'true')

    React.useEffect(() => {
        if(openBackInStock){
            window.openBIS()
        }
    },[openBackInStock])


    React.useEffect(() => {
        let _item = item.masterVariant
        const canBuyOnline = !!_item.attributes.find((attribute: any) => attribute.name === 'canBuyOnline')?.value
        let availabilityExists = _item?.availability
        let availableQuantity = availabilityExists?.availableQuantity
        const isAvailable =
            (availableQuantity > 0) ||
            (PROJECT_SETTINGS.inventoryMode === "TrackOnly" && availabilityExists)
        setIsAvailable(isAvailable && canBuyOnline)
        setShowBackInStock(!isAvailable && canBuyOnline && backInStockActive)
        setIsSellable(availabilityExists && canBuyOnline)
        setAvailableQta(availableQuantity)
        if (PROJECT_SETTINGS.inventoryMode === "TrackOnly" || (availableQuantity > 0)){
            if(availableQuantity <= 0){
                setItemWillArriveLater(true)
            }else if(PRODUCT_WITH_LIMITED_QTA_ENABLED != null){
                const attrs = PRODUCT_WITH_LIMITED_QTA_ENABLED.split("|");
                if (attrs.length === 2) {
                    const [enabled, qtaThresholdString] = attrs;
                    const qtaThreshold = Number(qtaThresholdString);
                    if (enabled === "true" && !isNaN(qtaThreshold)) {
                        if(availableQuantity >= 1 && availableQuantity <= qtaThreshold){
                            setShowLabelItemInStockWithLimitedQta(true);
                        }
                    }
                }
            }
        }
    },[])

    currentItem = item.masterVariant
    name = item.name
    const { sku, images, prices } = currentItem

    const energyLabel = getEnergyClassLabel(currentItem, t)
    const productSheetUrl = currentItem.attributes.find((attr: any) => attr.name === 'product-sheet-url' && attr.value)

    const { discounted } = getCurrentPrice(prices, userData) || {};

    let inWishlist = false;
    if (wishlist && wishlist.lineItems.length > 0) {
        inWishlist = wishlist.lineItems.some(item => item.variant && item.variant.sku === sku);
    }

    let productUrl = `${BRX_BASE_URL}/spare-parts/${sku}`

    let symbols = getSymbolBySku(sku)

    return (
        <>
            <div className="product-preview__top product-labels" style={{height: "70px"}}>
                {symbols && symbols.length > 0 &&
                    symbols.map((symbol: any) => {
                        let visibilityClass = getContentVisibility(symbol.visibility, "inline")
                        return (
                            symbol.imageUrl && symbol.type === "label" && (
                                <a key={symbol.id} className={`label-clickable mr-1 ${visibilityClass}`}
                                   onClick={() => window.symbolModal.showModal(symbol)}>
                                    <div className="label mb-1">
                                        {symbol.name}
                                    </div>
                                </a>
                            )
                        );
                    })
                }
            </div>

            <div className="product-content">
                <a style={{textDecoration: "none"}} href={productUrl}>
                    <div className="product-preview__gallery mb-2">
                        {images.length > 0
                            ? <img className="img-fluid" src={images[0].url} alt=""/>
                            : <img className="img-fluid" alt="placeholder" src={`${BRX_ASSETS_URL}/images/product_placeholder.png`}/>
                        }
                    </div>
                    <div className="row product-preview__header mb-2">
                        <div className="col-md-6 name">
                            {name?.[PROJECT_LANGUAGE]}
                            <div className="productSlug">{sku}</div>
                        </div>
                        <div className="col-md-6 promotion-preview">
                            <div className="promotion-preview__header">
                                <div className="prices">
                                    {getCurrentPrice(prices, userData)?.value.centAmount > 0 && (
                                        discounted ? (
                                            <>
                                                <div className="price price--strikethrough">{parsePrice(getCurrentPrice(prices, userData)?.value)}</div>
                                                <div className="price price--discounted">{parsePrice(discounted.value)}</div>
                                            </>
                                        ) : (
                                            <div className="price price--discounted">{parsePrice(getCurrentPrice(prices, userData)?.value)}</div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>

            <div className="product-links">
                <div className="energy_label">
                    {symbols && symbols.length > 0 &&
                        symbols.map((symbol: any, index: number) => {
                            let visibilityClass = getContentVisibility(symbol.visibility, "inline")
                            return (
                                symbol.imageUrl && symbol.type !== "label" && (
                                    <div className={visibilityClass} key={symbol.id}>
                                        <div className={`float-right ${index % 2 === 0 && symbols.length > 1 ? "pl-2" : ""}`}>
                                            <img
                                                className="icon-30"
                                                onClick={() => window.symbolModal.showModal(symbol)}
                                                src={symbol.imageUrl}
                                                alt={symbol.imageAlt}
                                                title={symbol.imageTitle}
                                            />
                                        </div>
                                    </div>
                                )
                            );
                        })
                    }
                    {SHOW_ENERGY_LABEL && (energyLabel || (productSheetUrl && productSheetUrl !== "")) &&
                        <>
                            {energyLabel &&
                                <a target="_blank" rel="noreferrer"
                                   href={`https://pi-exchange.smeg.it/energy/${sku}/${PROJECT_LANGUAGE}-${PROJECT_COUNTRY}`}
                                   aria-label={t("product.energyClassAriaLabel")}>
                                    <img className="icon-30" src={energyLabel.src} alt={energyLabel.alt}/>
                                </a>
                            }
                            {productSheetUrl && productSheetUrl !== "" &&
                                <a className={`font-weight-light ${energyLabel ? 'pl-3' : ''}`}
                                   href={productSheetUrl.value?.replaceAll(" en-GB", " en-IE")} target="_blank"
                                   rel="noreferrer">{t("product.productSheetLabel")}</a>
                            }
                        </>
                    }
                </div>
                <div className="product-link__buy text-center" style={{"minHeight": "57px"}}>
                    {isAvailable &&
                        <button data-id={sku} onClick={(e) => {
                            e.stopPropagation();
                            addLineItem(sku, false, true, 1)
                            openCartLayer();
                        }} className="btn_addToCart button-primary" title={t("ecommerce.common.product.addToCart")}>
                            {t("ecommerce.common.product.addToCart")}
                        </button>
                    }
                    {!isAvailable &&
                        <>
                            {isSellable && <div style={{"lineHeight": "18px", "padding": "0.375rem 0"}} className="focus" dangerouslySetInnerHTML={{__html: t("ecommerce.common.product.isOutOfStock")}}/>}
                            {/* Back in stock temporaneamente nascosto per i ricambi
                            {showBackInStock && (
                                <button onClick={() => {
                                    setOpenBackInStock({
                                        imageUrl: images.length > 0 ? images[0].url : undefined,
                                        sku: sku,
                                        name: name,
                                        title: t('ecommerce.common.product.backInStockTitle'),
                                        description: t('ecommerce.common.product.backInStockDescription')
                                    })
                                }} className="btn_secondary btn_backInStock">
                                    <span className="icon"><i className="far fa-bell"/></span>
                                    <span className="testo">{t('ecommerce.common.product.notifyMeWhenBackInStock')}</span>
                                </button>)
                            }
                            */}
                        </>
                    }
                </div>
                <div className="product-link__wishlist">
                    <button data-id={sku} onClick={() => addRemoveWishlistLineItem(sku)}
                            className={`${inWishlist && "inWishlist"} btn_addToWishlist`} title="Wishlist">
                        <span className="icon"/>
                        <span className="testo">{t("ecommerce.common.product.addToWishlist")}</span>
                        <span className="testo2">{t("ecommerce.common.product.addedToWishlist")}</span>
                    </button>
                </div>
            </div>

            <div className="bundle-information">
                {itemWillArriveLater &&
                    <div className="focus-info focus-info-small mt-3 text-center"
                         style={{color: 'var(--color-alert-light)'}}>{t('ecommerce.checkout.listing.item-will-arrive-late')}</div>
                }
                {showLabelItemInStockWithLimitedQta &&
                    <div className="focus-info focus-info-small mt-3 text-center"
                         style={{color: '#faa914'}}>{t('ecommerce.checkout.item-in-stock-limited-qta').replace("{qta}", availableQta.toString())}</div>
                }
                {showLabelItemInStock &&
                    <div className="focus-info focus-info-small mt-3 text-center"
                         style={{color: 'var(--color-success)'}}>{t('ecommerce.checkout.item-in-stock')}</div>
                }
            </div>

            <div className="free-field free-field--2 product-free-field product-preview__free-field"></div>
        </>
    )
};